import { createQuestionValueMap, getUpdatedItems, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, updateMapWithFields } from "../../../../common/summary-common/confirmationData";



export const defaultSubstanceInformation: Map<string, ConfirmationData> = new Map([
    ["f3b5f809-cca3-443f-b997-d9632ceefe28", { fontWeight: "bold", showBorder: true }],
    ["0d8fcccc-a79e-4c64-a0f4-9d34da120e27", { label: "Sí/No", showBorder: true }],
]);
const defaultSubstanceItems: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Sustancia", fontWeight: "bold" }],
    ["25138a2b-9339-4e1c-bb4f-f13970b9c26f", {}],
    ["5aa3a107-5ba6-4f40-ab21-5bf488f755ff", {}],
    ["68c29157-e96d-48fc-88ea-33fb1afe0ddf", { showBorder: true }],
]);
export const defaultSubstanceInformation2: Map<string, ConfirmationData> = new Map([
    ["b3f474f8-1374-47b6-85c5-7facc817826c", { fontWeight: "bold" }],
    ["8b3a5d82-eb5e-4cfc-8133-f23491642a69-opt1", { type: "checkbox" }],
    ["8b3a5d82-eb5e-4cfc-8133-f23491642a69-opt2", { type: "checkbox" }],
    ["8b3a5d82-eb5e-4cfc-8133-f23491642a69-opt3", { type: "checkbox" }],
    ["8b3a5d82-eb5e-4cfc-8133-f23491642a69-opt4", { type: "checkbox", showBorder: true }],
    ["77467a18-bdff-4170-a484-0280ef4426d4", { fontWeight: "bold" }],
    ["158d16a0-1de7-4815-a29d-fe2453c0e484", { label: "Sí/No" }]
]);

export const updateSubstanceInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }

    const answersMap = createQuestionValueMap(page);
    cd = new Map([
        ...cd,
        ...defaultSubstanceInformation,
    ])
    const updatedSubstanceItems = getUpdatedItems(page, "b73d6f29-77cb-4229-83e5-bd16c1be2755", "4adc8619-2c7b-4eb4-9f0f-0ad056866a8a", defaultSubstanceItems, false);


    if (answersMap.get("0d8fcccc-a79e-4c64-a0f4-9d34da120e27")?.value === "Sí") {
        cd = new Map([
            ...cd,
            ...updatedSubstanceItems,
        ])
    }
    cd = new Map([
        ...cd,
        ...defaultSubstanceInformation2,
    ])
    return updateMapWithFields(mapToTupleArray(answersMap), cd);
}